import { Col, HelpBlock, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import * as Commonmark from 'react-commonmark';
import { Field } from 'redux-form';
import FieldFormControl from '../../../../../../../components/FieldFormControl';
import { isRequired } from '../../../../../../../util/validators';
import * as React from 'react';
import { FormattedNumber } from 'react-intl';
import { FaInfoCircle, FaSpinner } from 'react-icons/fa';
import { get } from 'lodash';
import { windowSize } from '../../../../../../../hooks/windowSize';
import { gadgetDeprecation, replaceBenefitTextPlaceHolder } from '../../../../../../../helpers/Quote';
import { GadgetMoreInfo } from '../../GadgetMoreInfo';
import { EnhancedTripDisruptionMoreInfo } from '../../EnhancedTripDisruptionMoreInfo';
import { CONSTANTS } from '../../../../../../../util/constants';

export function DynamicTextWithAdd(
  {
    title,
    dynamicText,
    name,
    bodyText = null,
    moreInfo= '',
    onOptionClick,
    visibilityOfDynamicText,
    currency,
    boltOnTotal,
    isBoltOnFree = false,
    visibilityName = null,
    disabledCase = null,
    validationMessage = 'both',
    props = null,
    optionKeyName = null,
    popOverTitle = null,
    popOverText = null,
    benefits = [],
    isMta = false,
    coverLevel = null,
  }) {

  const popover = (
    <Popover id={`popover-trigger-${name}`}>
      <Commonmark source={popOverTitle}/>
      <Commonmark source={popOverText}/>
    </Popover>
  );

  const isMobile = windowSize(600).isMobile;
  const error = get(props, `synchronousError.visibility.options.${optionKeyName}`, null);
  let hasIcon = false;
  let source = '';
  let moreInfoComponent = null;

  switch (optionKeyName) {
    case CONSTANTS.ADDONS.EXCESS_WAIVER:
      hasIcon = true;
      source = require('../../../img/excess_waiver_color_2.svg');
      break;
    case CONSTANTS.ADDONS.ENHANCED_TRIP_DISRUPTION:
      hasIcon = true;
      source = require('../../../img/enhanced_trip_disruption_color.svg');
      moreInfoComponent = moreInfo ? (<EnhancedTripDisruptionMoreInfo infoText={moreInfo} />) : null
      break;
    case CONSTANTS.ADDONS.GOLF_COVER:
      hasIcon = true;
      source = get(props, `options.${optionKeyName}`, false) ? require('../../../img/golf_cover_color.svg') : require('../../../img/golf_cover_grey.svg');
      break;
    case CONSTANTS.ADDONS.GADGET_COVER:
      hasIcon = true;
      const deprecation = gadgetDeprecation(benefits, isMta)
      moreInfoComponent = (<GadgetMoreInfo deprecation={deprecation} />)
      source = require('../../../img/gadget_cover_color_2.svg');
      dynamicText = replaceBenefitTextPlaceHolder(dynamicText, benefits, optionKeyName, isMta, coverLevel)
      break;
  }

  const renderPrice = () => {
    return (
      <>
        <span style={{ textDecoration: isBoltOnFree ? 'line-through' : '' }}>
          <FormattedNumber
            value={boltOnTotal}
            style="currency"
            currency={currency}
          />
        </span>

        {isBoltOnFree &&
          <FormattedNumber
            value={0}
            style="currency"
            currency={currency}
          />
        }
      </>
    )
  }
  const handleYesClick = () => {
      props.change(name, true);
      onOptionClick();
  };

  const handleNoClick = () => {
      props.change(name, null);
      onOptionClick();
  };

  return (
    <div className="options-section medical-question medical-section">

      <Row className="dynamic-row">
        {hasIcon && (
          <Col sm={12}>
            <div className="question-text">
              {!isMobile && (
                <Row>
                  <Col xs={2}>
                    <img src={source} alt="Admiral" className="additional-cover-icon-desktop"/>
                  </Col>
                  <Col xs={10}>
                    <div className="title">
                      {title}
                      {popOverText && (
                        <OverlayTrigger
                          trigger="click"
                          rootClose={true}
                          placement="right"
                          overlay={popover}
                        >
                          <FaInfoCircle className="info-btn"/>
                        </OverlayTrigger>
                      )}
                    </div>
                      <div className="bolton-price">
                        {boltOnTotal ? (
                          renderPrice()
                        ) : (
                          <FaSpinner className="fa-spin"/>
                        )}
                      </div>
                    <Commonmark
                      source={bodyText}
                    />
                  </Col>
                </Row>
              )}
              {isMobile && (
                <>
                  <div style={{ display: 'flex' }}>
                    <img src={source} alt="Admiral" className="additional-cover-icon-mobile"/>
                    <div className="title" style={{ paddingTop: '15px' }}>
                      {title}
                      {popOverText && (
                        <OverlayTrigger
                          trigger="click"
                          rootClose={true}
                          placement="right"
                          overlay={popover}
                        >
                          <FaInfoCircle className="info-btn"/>
                        </OverlayTrigger>
                      )}
                    </div>
                  </div>
                    <div className="bolton-price">
                      {boltOnTotal ? (
                        renderPrice()
                      ) : (
                        <FaSpinner className="fa-spin"/>
                      )}
                    </div>
                  <Commonmark
                    source={bodyText}
                  />
                </>
              )}
            </div>
            {moreInfoComponent && (
              <>
                {moreInfoComponent}
              </>
            )}
          </Col>
        )}

        {!hasIcon && (
          <Col sm={12}>
            <div className="question-text">
              <div className="title">
                {title}
                {popOverText && (
                  <OverlayTrigger
                    trigger="click"
                    rootClose={true}
                    placement="right"
                    overlay={popover}
                  >
                    <FaInfoCircle className="info-btn"/>
                  </OverlayTrigger>
                )}
              </div>
              <Commonmark
                source={bodyText}
              />
            </div>
            {visibilityOfDynamicText &&
              <Commonmark
                source={dynamicText}
              />}
          </Col>
        )}

        <Col sm={6} className={'col-sm-offset-3'} style={{ padding: '15px 0 10px' }}>
          <Row className="dynamic-row">
            <Col xs={12}>
              {/*Beware, some CSS is stripping padding from the column. Should probably use negative margins
              instead to avoid doing this.*/}
              <Col sm={12} lg={6} className="radio-button-yes">
                <Field
                  name={visibilityName ? `visibility.${visibilityName}` : `visibility.${name}`}
                  type="radio"
                  format={null}
                  value={true}
                  complexValue={true}
                  className="answer-new"
                  validationMessage={validationMessage}
                  component={FieldFormControl}
                  validate={[isRequired]}
                  disabled={disabledCase}
                  onClick={handleYesClick}
                >
                  <div className="medical-btn-new yes">
                    Yes
                  </div>
                </Field>
              </Col>
              <Col sm={12} lg={6} className="radio-button-no">
                <Field
                  name={visibilityName ? `visibility.${visibilityName}` : `visibility.${name}`}
                  type="radio"
                  format={null}
                  value={false}
                  complexValue={true}
                  className="answer-new"
                  validationMessage={validationMessage}
                  component={FieldFormControl}
                  validate={[isRequired]}
                  onClick={handleNoClick}
                  disabled={disabledCase}
                >
                  <div className="medical-btn-new no">
                    No
                  </div>
                </Field>
              </Col>
            </Col>
            {error && validationMessage !== 'both' && props.submitFailed && (
              <Row style={{ textAlign: 'center' }}>
                <Col>
                  <div className={error ? 'has-error' : ''}>
                    {<HelpBlock>{error}</HelpBlock>}
                  </div>
                </Col>
              </Row>
            )}
          </Row>
        </Col>
        <Col xs={12}>
          {visibilityOfDynamicText &&
            <Commonmark
              source={dynamicText}
            />}
        </Col>
      </Row>
    </div>
  );

}
